"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.handleItemSelection = handleItemSelection;
exports.listReducer = listReducer;
exports.moveHighlight = moveHighlight;
exports.toggleSelection = toggleSelection;
var _listActions = require("./listActions.types");
/**
 * Looks up the next valid item to highlight within the list.
 *
 * @param currentIndex The index of the start of the search.
 * @param lookupDirection Whether to look for the next or previous item.
 * @param items The array of items to search.
 * @param includeDisabledItems Whether to include disabled items in the search.
 * @param isItemDisabled A function that determines whether an item is disabled.
 * @param wrapAround Whether to wrap around the list when searching.
 * @returns The index of the next valid item to highlight or -1 if no valid item is found.
 */ function findValidItemToHighlight(currentIndex, lookupDirection, items, includeDisabledItems, isItemDisabled, wrapAround) {
    if (items.length === 0 || !includeDisabledItems && items.every(function(item, itemIndex) {
        return isItemDisabled(item, itemIndex);
    })) {
        return -1;
    }
    var nextFocus = currentIndex;
    for(;;){
        // No valid items found
        if (!wrapAround && lookupDirection === 'next' && nextFocus === items.length || !wrapAround && lookupDirection === 'previous' && nextFocus === -1) {
            return -1;
        }
        var nextFocusDisabled = includeDisabledItems ? false : isItemDisabled(items[nextFocus], nextFocus);
        if (nextFocusDisabled) {
            nextFocus += lookupDirection === 'next' ? 1 : -1;
            if (wrapAround) {
                nextFocus = (nextFocus + items.length) % items.length;
            }
        } else {
            return nextFocus;
        }
    }
}
/**
 * Gets the next item to highlight based on the current highlighted item and the search direction.
 *
 * @param previouslyHighlightedValue The item from which to start the search for the next candidate.
 * @param offset The offset from the previously highlighted item to search for the next candidate or a special named value ('reset', 'start', 'end').
 * @param context The list action context.
 *
 * @returns The next item to highlight or null if no item is valid.
 */ function moveHighlight(previouslyHighlightedValue, offset, context) {
    var items = context.items, isItemDisabled = context.isItemDisabled, disableListWrap = context.disableListWrap, disabledItemsFocusable = context.disabledItemsFocusable, itemComparer = context.itemComparer, focusManagement = context.focusManagement;
    // TODO: make this configurable
    // The always should be an item highlighted when focus is managed by the DOM
    // so that it's accessible by the `tab` key.
    var defaultHighlightedIndex = focusManagement === 'DOM' ? 0 : -1;
    var maxIndex = items.length - 1;
    var previouslyHighlightedIndex = previouslyHighlightedValue == null ? -1 : items.findIndex(function(item) {
        return itemComparer(item, previouslyHighlightedValue);
    });
    var nextIndexCandidate;
    var lookupDirection;
    var wrapAround = !disableListWrap;
    switch(offset){
        case 'reset':
            if (defaultHighlightedIndex === -1) {
                return null;
            }
            nextIndexCandidate = 0;
            lookupDirection = 'next';
            wrapAround = false;
            break;
        case 'start':
            nextIndexCandidate = 0;
            lookupDirection = 'next';
            wrapAround = false;
            break;
        case 'end':
            nextIndexCandidate = maxIndex;
            lookupDirection = 'previous';
            wrapAround = false;
            break;
        default:
            {
                var newIndex = previouslyHighlightedIndex + offset;
                if (newIndex < 0) {
                    if (!wrapAround && previouslyHighlightedIndex !== -1 || Math.abs(offset) > 1) {
                        nextIndexCandidate = 0;
                        lookupDirection = 'next';
                    } else {
                        nextIndexCandidate = maxIndex;
                        lookupDirection = 'previous';
                    }
                } else if (newIndex > maxIndex) {
                    if (!wrapAround || Math.abs(offset) > 1) {
                        nextIndexCandidate = maxIndex;
                        lookupDirection = 'previous';
                    } else {
                        nextIndexCandidate = 0;
                        lookupDirection = 'next';
                    }
                } else {
                    nextIndexCandidate = newIndex;
                    lookupDirection = offset >= 0 ? 'next' : 'previous';
                }
            }
    }
    var nextIndex = findValidItemToHighlight(nextIndexCandidate, lookupDirection, items, disabledItemsFocusable, isItemDisabled, wrapAround);
    // If there are no valid items to highlight, return the previously highlighted item (if it's still valid).
    if (nextIndex === -1 && previouslyHighlightedValue !== null && !isItemDisabled(previouslyHighlightedValue, previouslyHighlightedIndex)) {
        return previouslyHighlightedValue;
    }
    var _items_nextIndex;
    return (_items_nextIndex = items[nextIndex]) !== null && _items_nextIndex !== void 0 ? _items_nextIndex : null;
}
/**
 * Toggles the selection of an item.
 *
 * @param item Item to toggle.
 * @param selectedValues Already selected items.
 * @param selectionMode The number of items that can be simultanously selected.
 * @param itemComparer A custom item comparer function.
 *
 * @returns The new array of selected items.
 */ function toggleSelection(item, selectedValues, selectionMode, itemComparer) {
    if (selectionMode === 'none') {
        return [];
    }
    if (selectionMode === 'single') {
        // if the item to select has already been selected, return the original array
        if (itemComparer(selectedValues[0], item)) {
            return selectedValues;
        }
        return [
            item
        ];
    }
    // The toggled item is selected; remove it from the selection.
    if (selectedValues.some(function(sv) {
        return itemComparer(sv, item);
    })) {
        return selectedValues.filter(function(sv) {
            return !itemComparer(sv, item);
        });
    }
    // The toggled item is not selected - add it to the selection.
    return _to_consumable_array(selectedValues).concat([
        item
    ]);
}
/**
 * Handles item selection in a list.
 *
 * @param item - The item to be selected.
 * @param state - The current state of the list.
 * @param context - The context of the list action.
 * @returns The new state of the list after the item has been selected, or the original state if the item is disabled.
 */ function handleItemSelection(item, state, context) {
    var itemComparer = context.itemComparer, isItemDisabled = context.isItemDisabled, selectionMode = context.selectionMode, items = context.items;
    var selectedValues = state.selectedValues;
    var itemIndex = items.findIndex(function(i) {
        return itemComparer(item, i);
    });
    if (isItemDisabled(item, itemIndex)) {
        return state;
    }
    // if the item is already selected, remove it from the selection, otherwise add it
    var newSelectedValues = toggleSelection(item, selectedValues, selectionMode, itemComparer);
    return _object_spread_props(_object_spread({}, state), {
        selectedValues: newSelectedValues,
        highlightedValue: item
    });
}
function handleKeyDown(key, state, context) {
    var previouslySelectedValue = state.highlightedValue;
    var orientation = context.orientation, pageSize = context.pageSize;
    switch(key){
        case 'Home':
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: moveHighlight(previouslySelectedValue, 'start', context)
            });
        case 'End':
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: moveHighlight(previouslySelectedValue, 'end', context)
            });
        case 'PageUp':
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: moveHighlight(previouslySelectedValue, -pageSize, context)
            });
        case 'PageDown':
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: moveHighlight(previouslySelectedValue, pageSize, context)
            });
        case 'ArrowUp':
            if (orientation !== 'vertical') {
                break;
            }
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: moveHighlight(previouslySelectedValue, -1, context)
            });
        case 'ArrowDown':
            if (orientation !== 'vertical') {
                break;
            }
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: moveHighlight(previouslySelectedValue, 1, context)
            });
        case 'ArrowLeft':
            {
                if (orientation === 'vertical') {
                    break;
                }
                var offset = orientation === 'horizontal-ltr' ? -1 : 1;
                return _object_spread_props(_object_spread({}, state), {
                    highlightedValue: moveHighlight(previouslySelectedValue, offset, context)
                });
            }
        case 'ArrowRight':
            {
                if (orientation === 'vertical') {
                    break;
                }
                var offset1 = orientation === 'horizontal-ltr' ? 1 : -1;
                return _object_spread_props(_object_spread({}, state), {
                    highlightedValue: moveHighlight(previouslySelectedValue, offset1, context)
                });
            }
        case 'Enter':
        case ' ':
            if (state.highlightedValue === null) {
                return state;
            }
            return handleItemSelection(state.highlightedValue, state, context);
        default:
            break;
    }
    return state;
}
function handleBlur(state, context) {
    if (context.focusManagement === 'DOM') {
        return state;
    }
    return _object_spread_props(_object_spread({}, state), {
        highlightedValue: null
    });
}
function textCriteriaMatches(nextFocus, searchString, stringifyItem) {
    var _stringifyItem;
    var text = (_stringifyItem = stringifyItem(nextFocus)) === null || _stringifyItem === void 0 ? void 0 : _stringifyItem.trim().toLowerCase();
    if (!text || text.length === 0) {
        // Make item not navigable if stringification fails or results in empty string.
        return false;
    }
    return text.startsWith(searchString);
}
function handleTextNavigation(state, searchString, context) {
    var items = context.items, isItemDisabled = context.isItemDisabled, disabledItemsFocusable = context.disabledItemsFocusable, getItemAsString = context.getItemAsString;
    var startWithCurrentItem = searchString.length > 1;
    var nextItem = startWithCurrentItem ? state.highlightedValue : moveHighlight(state.highlightedValue, 1, context);
    for(var index = 0; index < items.length; index += 1){
        // Return un-mutated state if looped back to the currently highlighted value
        if (!nextItem || !startWithCurrentItem && state.highlightedValue === nextItem) {
            return state;
        }
        if (textCriteriaMatches(nextItem, searchString, getItemAsString) && (!isItemDisabled(nextItem, items.indexOf(nextItem)) || disabledItemsFocusable)) {
            // The nextItem is the element to be highlighted
            return _object_spread_props(_object_spread({}, state), {
                highlightedValue: nextItem
            });
        }
        // Move to the next element.
        nextItem = moveHighlight(nextItem, 1, context);
    }
    // No item matches the text search criteria
    return state;
}
function handleItemsChange(items, previousItems, state, context) {
    var itemComparer = context.itemComparer, focusManagement = context.focusManagement;
    var newHighlightedValue = null;
    if (state.highlightedValue != null) {
        var _items_find;
        newHighlightedValue = (_items_find = items.find(function(item) {
            return itemComparer(item, state.highlightedValue);
        })) !== null && _items_find !== void 0 ? _items_find : null;
    } else if (focusManagement === 'DOM' && previousItems.length === 0) {
        newHighlightedValue = moveHighlight(null, 'reset', context);
    }
    var _state_selectedValues;
    // exclude selected values that are no longer in the items list
    var selectedValues = (_state_selectedValues = state.selectedValues) !== null && _state_selectedValues !== void 0 ? _state_selectedValues : [];
    var newSelectedValues = selectedValues.filter(function(selectedValue) {
        return items.some(function(item) {
            return itemComparer(item, selectedValue);
        });
    });
    return _object_spread_props(_object_spread({}, state), {
        highlightedValue: newHighlightedValue,
        selectedValues: newSelectedValues
    });
}
function handleResetHighlight(state, context) {
    return _object_spread_props(_object_spread({}, state), {
        highlightedValue: moveHighlight(null, 'reset', context)
    });
}
function handleHighlightLast(state, context) {
    return _object_spread_props(_object_spread({}, state), {
        highlightedValue: moveHighlight(null, 'end', context)
    });
}
function handleClearSelection(state, context) {
    return _object_spread_props(_object_spread({}, state), {
        selectedValues: [],
        highlightedValue: moveHighlight(null, 'reset', context)
    });
}
function listReducer(state, action) {
    var type = action.type, context = action.context;
    switch(type){
        case _listActions.ListActionTypes.keyDown:
            return handleKeyDown(action.key, state, context);
        case _listActions.ListActionTypes.itemClick:
            return handleItemSelection(action.item, state, context);
        case _listActions.ListActionTypes.blur:
            return handleBlur(state, context);
        case _listActions.ListActionTypes.textNavigation:
            return handleTextNavigation(state, action.searchString, context);
        case _listActions.ListActionTypes.itemsChange:
            return handleItemsChange(action.items, action.previousItems, state, context);
        case _listActions.ListActionTypes.resetHighlight:
            return handleResetHighlight(state, context);
        case _listActions.ListActionTypes.highlightLast:
            return handleHighlightLast(state, context);
        case _listActions.ListActionTypes.clearSelection:
            return handleClearSelection(state, context);
        default:
            return state;
    }
}
